export default {"src":"/_next/static/media/update_spacecraft.1b175d0c.svg","height":2700,"width":1333,"blurWidth":0,"blurHeight":0};